<template>
  <div class="pa-5">
    <!-- <v-skeleton-loader
      class="mx-auto"
      type="card-heading, image, actions"
    ></v-skeleton-loader> -->
    <v-card shaped class="elevation-10">
      <v-sheet height="64">
        <v-toolbar
          flat
        >
          <v-btn
            outlined
            class="mr-4"
            color="grey darken-2"
            @click="setToday"
          >
            วันนี้
          </v-btn>
          <v-btn
            fab
            text
            small
            color="grey darken-2"
            @click="prev"
          >
            <v-icon small>
              mdi-chevron-left
            </v-icon>
          </v-btn>
          <v-toolbar-title v-if="$refs.calendar">
            {{ $refs.calendar.title }}
          </v-toolbar-title>
          <v-btn
            fab
            text
            small
            color="grey darken-2"
            @click="next"
          >
            <v-icon small>
              mdi-chevron-right
            </v-icon>
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn color="success" @click="add_event">
            <v-icon>mdi-add</v-icon>
            เพิ่มงาน
          </v-btn>
          
        </v-toolbar>
      </v-sheet>
      <v-sheet height="700">
        <v-calendar
          locale="th"
          ref="calendar"
          color="primary"
          v-model="calendar_options.focus"
          :type="calendar_options.type"
          @click:event="showEvent"
          :events="events"
          :event-color="getEventColor"
        ></v-calendar>
        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          offset-x
        >
          <v-card
            color="grey lighten-4"
            min-width="350px"
            flat
          >
            <v-toolbar
              :color="selectedEvent.color"
              dark
            >
              <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="edit_event(selectedEvent)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon @click="confirm_delete_dialog(selectedEvent.id)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <span v-html="selectedEvent.description"></span>
            </v-card-text>
            <v-card-actions>
              <v-btn
                outlined
                :color="selectedEvent.color"
                @click="selectedOpen = false"
              >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>
    </v-card>

    <v-dialog width="500" v-model="add_dialog">
      <v-card tile>
        <v-card-title>แบบฟอร์มเพิ่มงาน</v-card-title>
        <v-subheader>เลือกวันที่ดำเนินการ</v-subheader>
        <v-card-text>
          <v-date-picker
            v-model="form.dates"
            range
            full-width
            :color="form.color"
          ></v-date-picker>

          <v-text-field v-model="form.name" label="ชื่องาน" outlined dense></v-text-field>
          <v-textarea v-model="form.description" label="รายละเอียดงาน" outlined dense rows="2"></v-textarea>
        </v-card-text>

        <v-subheader>เลือกสีที่แสดง</v-subheader>
        <v-card-text>
          <v-btn-toggle v-model="form.color">
            <v-btn color="#1976D2" floating value="#1976D2"></v-btn>
            <v-btn color="#424242" floating value="#424242"></v-btn>
            <v-btn color="#82B1FF" floating value="#82B1FF"></v-btn>
            <v-btn color="#FF5252" floating value="#FF5252"></v-btn>
            <v-btn color="#2196F3" floating value="#2196F3"></v-btn>
            <v-btn color="#4CAF50" floating value="#4CAF50"></v-btn>
            <v-btn color="#FFC107" floating value="#FFC107"></v-btn>
          </v-btn-toggle>
        </v-card-text>

        <v-card-actions>
          <v-btn color="primary" @click="submit">{{ form_type === 'NEW' ? 'บันทึก' : 'แก้ไข' }}</v-btn>
          <v-btn color="error" @click="add_dialog = false; clear_form()">ยกเลิก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirm_delete" max-width="500">
      <v-card>
        <v-card-title>ยืนยันการลบงาน</v-card-title>
        <v-card-text>คุณต้องการลบงานนี้ใช่หรือไม่</v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="delete_event()">ยืนยัน</v-btn>
          <v-btn color="secondary" @click="confirm_delete = false">ยกเลิก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
export default {
  data: () => ({
    events: [],
    add_dialog: false,
    form_type: '',
    form: {
      dates: [],
      color: '#1976D2',
      name: '',
      description: ''
    },
    selected_delete: '',
    confirm_delete: false,
    calendar_options: {
      focus: '',
      type: 'month'
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
  }),
  created() {
    this.getEvents();
  },
  mounted () {
    this.$refs.calendar.checkChange()
  },
  methods: {
    add_event() {
      this.clear_form();
      this.form_type = 'NEW';
      this.add_dialog = true;
    },
    edit_event(data) {
      console.log([data.start, data.end])
      this.form = {
        id: data.id,
        dates: [data.start, data.end],
        color: data.color,
        name: data.name,
        description: data.description
      }
      this.form_type = 'EDIT';
      this.add_dialog = true;
    },
    confirm_delete_dialog(id) {
      this.confirm_delete = true;
      this.selected_delete = id;
    },
    delete_event() {
      this.$store.dispatch('calendar/delete', this.selected_delete).then(res => {
        this.confirm_delete = false;
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'success',
          message: res.message
        });
        this.getEvents();
      }).catch(() => {
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'error',
          message: 'เกิดข้อผิดพลาดบางอย่าง'
        });
      });
    },
    submit() {
      this.form.dates.sort();
      this.$store.dispatch(this.form_type === 'NEW' ? 'calendar/add_event' : 'calendar/edit', this.form).then(res => {
        this.add_dialog = false;
        this.clear_form();
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'success',
          message: res.message
        })
        this.getEvents();
      }).catch(() => {
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'error',
          message: 'เกิดข้อผิดพลาดบางอย่าง'
        });
      });
    },
    getEvents() {
      this.$store.dispatch('calendar/get_events').then(data => this.events = data);
    },
    getEventColor (event) {
      return event.color
    },
    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        setTimeout(() => {
          this.selectedOpen = true
        }, 10)
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        setTimeout(open, 10)
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },
    setToday () {
      this.calendar_options.focus = ''
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    clear_form() {
      this.form = {
        dates: [],
        color: '#1976D2',
        name: ''
      }
    }
  }
}
</script>